export default {
      id: "partner-adwords-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#partner-adwords",
      toString: function () {
        return this.url;
      }
    }